<template>
  <div style="overflow-y: auto;height: 530px;">
    <div v-for="item in versionList" :key="item.versionCode" class="text item">
      <h5>
        {{ item.versionNo }}
      </h5>
      <span style="font-size:14px;">{{$l('INDEX.form_label_publishTime') || '发布日期'}}：{{ item.publishTime }}</span>
      <br />
      <div class="mb-2">
        <span style="font-size:14px;">{{$l('INDEX.form_label_publishDescription') || '发布说明'}}：</span>
      </div>
      <div v-html="item.publishDescription">{{ item.publishDescription }}</div>
      <el-divider></el-divider>
    </div>
    <div style="text-align: center" v-if="!versionList || !versionList.length">
      <img src="/image/static/img/nodata.png" />
      <p class="no-data">
        {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      versionList: [],
      publishDescription: ''
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$api.sysVersionDisplayListApi({}).then((res) => {
        this.versionList = res.body.data
      })
    }
  }
}
</script>
<style scoped>
h3 {
  text-align: center;
  display: inline;
}
</style>
